export const GET_ASSIGNED_MATCHES_BEGIN = 'GET_ASSIGNED_MATCHES_BEGIN';
export const GET_ASSIGNED_MATCHES_ERROR = 'GET_ASSIGNED_MATCHES_ERROR';
export const GET_ASSIGNED_MATCHES_SUCCESS = 'GET_ASSIGNED_MATCHES_SUCCESS';
export const GET_ASSIGNED_MATCHES_FOR_AWARDS_BEGIN = 'GET_ASSIGNED_MATCHES_FOR_AWARDS_BEGIN';
export const GET_ASSIGNED_MATCHES_FOR_AWARDS_ERROR = 'GET_ASSIGNED_MATCHES_FOR_AWARDS_ERROR';
export const GET_ASSIGNED_MATCHES_FOR_AWARDS_SUCCESS = 'GET_ASSIGNED_MATCHES_FOR_AWARDS_SUCCESS';

export const SET_ASSIGNED_MATCHES_CURRENT_PAGE = 'SET_ASSIGNED_MATCHES_CURRENT_PAGE'
export const SET_ASSIGNED_TEAMS_COUNT = 'SET_ASSIGNED_TEAMS_COUNT'
export const UPDATE_ASSIGNED_MATCHES_ON_SUBMIT = 'UPDATE_ASSIGNED_MATCHES_ON_SUBMIT'